import { render, staticRenderFns } from "./PlaceBetButton.vue?vue&type=template&id=a6002248&"
import script from "./PlaceBetButton.vue?vue&type=script&lang=js&"
export * from "./PlaceBetButton.vue?vue&type=script&lang=js&"
import style0 from "./PlaceBetButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports